.match {
  color: #f8ffff;
  background-color: #4caccc;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlV0aWxzLm1vZHVsZS5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5tYXRjaFxuICBjb2xvcjogI2Y4ZmZmZlxuICBiYWNrZ3JvdW5kLWNvbG9yOiAjNGNhY2NjXG4iXX0= */